import judgement1 from '@/assets/tenders/judgement-1.pdf';
import judgement2 from '@/assets/tenders/judgement-2.pdf';
import judgement3 from '@/assets/tenders/judgement-3.pdf';
import judgement4 from '@/assets/tenders/judgement-4.pdf';

import stat1 from '@/assets/tenders/stat-1.pdf';
import stat2 from '@/assets/tenders/stat-2.pdf';
import stat3 from '@/assets/tenders/stat-3.pdf';
import stat4 from '@/assets/tenders/stat-4.pdf';
import stat5 from '@/assets/tenders/stat-5.pdf';
import stat6 from '@/assets/tenders/stat-6.pdf';
import stat7 from '@/assets/tenders/stat-7.pdf';

export interface KnowledgeDocument {
  srNo: number;
  title: string;
  date: string;
  pdfUrl: string;
  category?: string;
}

export const judgementsData: KnowledgeDocument[] = [
  {
    srNo: 1,
    title: "Order of UP High Court on petition against export duty on ethanol",
    date: "01-08-2025",
    pdfUrl: judgement1,
    category: "High Court Order"
  },
  {
    srNo: 2,
    title: "9 bench SC Judgement on Industrial Alcohol",
    date: "23-10-2024",
    pdfUrl: judgement2,
    category: "Supreme Court Ruling"
  },
  {
    srNo: 3,
    title: "TS High Court Interim Relief Jurala",
    date: "21-09-2023",
    pdfUrl: judgement3,
    category: "High Court Order"
  },
  {
    srNo: 4,
    title: "Excise Removal",
    date: "21-12-2016",
    pdfUrl: judgement4,
    category: "Notification"
  }
];

export const statisticsData: KnowledgeDocument[] = [
  {
    srNo: 1,
    title: "ESY 2025-26 C-1 Allocation vs Offer Ethanol Summary",
    date: "19-01-2026",
    pdfUrl: stat1,
    category: "Allocation Summary"
  },
  {
    srNo: 2,
    title: "Ethanol Supplied To Oil Marketing Companies",
    date: "31-12-2025",
    pdfUrl: stat2,
    category: "Supply Data"
  },
  {
    srNo: 3,
    title: "Monthly Avg Prices of Maize & SoyaBean (₹/MT)",
    date: "06-05-2025",
    pdfUrl: stat3,
    category: "Market Pricing"
  },
  {
    srNo: 4,
    title: "Unlocking ₹35,000 Crore for Farmers: The Untapped Potential of Grain Ethanol",
    date: "12-04-2025",
    pdfUrl: stat4,
    category: "Economic Impact"
  },
  {
    srNo: 5,
    title: "Basic Price Of Ethanol As Per Feedstock Paid By OMC's",
    date: "18-02-2025",
    pdfUrl: stat5,
    category: "Pricing Schedule"
  },
  {
    srNo: 6,
    title: "Rice and Maize DDGS Export Data 2022-2024",
    date: "15-02-2025",
    pdfUrl: stat6,
    category: "Export Statistics"
  },
  {
    srNo: 7,
    title: "Maize Sowing and Cultivation Table (Rabi, Kharif and Spring)",
    date: "23-12-2024",
    pdfUrl: stat7,
    category: "Agri Data"
  }
];
